module.exports = __webpack_public_path__ + "img/tokyo.d1ee8fad.jpg";